import { render } from "./licenceManagementOverview.vue?vue&type=template&id=16f72696&scoped=true&ts=true"
import script from "./licenceManagementOverview.vue?vue&type=script&lang=ts"
export * from "./licenceManagementOverview.vue?vue&type=script&lang=ts"

import "./licenceManagementOverview.vue?vue&type=style&index=0&id=16f72696&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f72696"]])

export default __exports__